import { axiosInstance } from "../../../api/axiosInstance.tsx";

export type RollingForecastJenis = "pendapatan" | "biaya" | string;

export interface RollingForecastDetail {
  id: string;
  rollingForecastId: string;
  prediksiBulanStartDate: string;
  prediksiBulanEndDate: string;
  prediksiBulanDuration: number;
  januaryRkap: number;
  januaryBobot?: number;
  januaryForecast: number;
  februaryRkap: number;
  februaryBobot?: number;
  februaryForecast: number;
  marchRkap: number;
  marchBobot?: number;
  marchForecast: number;
  aprilRkap: number;
  aprilBobot?: number;
  aprilForecast: number;
  mayRkap: number;
  mayBobot?: number;
  mayForecast: number;
  juneRkap: number;
  juneBobot?: number;
  juneForecast: number;
  julyRkap: number;
  julyBobot?: number;
  julyForecast: number;
  augustRkap: number;
  augustBobot?: number;
  augustForecast: number;
  septemberRkap: number;
  septemberBobot?: number;
  septemberForecast: number;
  octoberRkap: number;
  octoberBobot?: number;
  octoberForecast: number;
  novemberRkap: number;
  novemberBobot?: number;
  novemberForecast: number;
  decemberRkap: number;
  decemberBobot?: number;
  decemberForecast: number;
  rencanaBisnis: number;
  realisasi: number;
  createdAt: string;
  updatedAt: string;
}

export interface RollingForecast {
  id: string;
  rollingForecastName: string;
  nilaiProject: number;
  projectName: string;
  source?: string;
  jenis: RollingForecastJenis;
  projectNumber: string;
  detail: string;
  region?: string;
  sabValue?: number;
  rabValue?: number;
  rapValue?: number;
  estIncome?: number;
  estExpense?: number;
  projectType?: string;
  projectPhase?: string;
  startDate?: string;
  endDate?: string;
  asOfSelected: number;
  createdAt: string;
  updatedAt: string;
  details: RollingForecastDetail[];
}

export interface RollingForecastDetailPayload {
  prediksiBulanStartDate: string;
  prediksiBulanEndDate: string;
  prediksiBulanDuration: number;
  januaryRkap: number;
  januaryBobot?: number;
  januaryForecast: number;
  februaryRkap: number;
  februaryBobot?: number;
  februaryForecast: number;
  marchRkap: number;
  marchBobot?: number;
  marchForecast: number;
  aprilRkap: number;
  aprilBobot?: number;
  aprilForecast: number;
  mayRkap: number;
  mayBobot?: number;
  mayForecast: number;
  juneRkap: number;
  juneBobot?: number;
  juneForecast: number;
  julyRkap: number;
  julyBobot?: number;
  julyForecast: number;
  augustRkap: number;
  augustBobot?: number;
  augustForecast: number;
  septemberRkap: number;
  septemberBobot?: number;
  septemberForecast: number;
  octoberRkap: number;
  octoberBobot?: number;
  octoberForecast: number;
  novemberRkap: number;
  novemberBobot?: number;
  novemberForecast: number;
  decemberRkap: number;
  decemberBobot?: number;
  decemberForecast: number;
  rencanaBisnis: number;
  realisasi: number;
}

export interface RollingForecastPayload {
  rollingForecastName: string;
  nilaiProject: number;
  projectName: string;
  jenis: RollingForecastJenis;
  projectNumber: string;
  detail: string;
  asOfSelected: number;
  details: RollingForecastDetailPayload[];
}

export const getRollingForecasts = async (): Promise<RollingForecast[]> => {
  const response = await axiosInstance.get<RollingForecast[]>("/projectmanagement/rolling-forecast/");
  return response.data;
};

export const getRollingForecastById = async (id: string): Promise<RollingForecast> => {
  const response = await axiosInstance.get<RollingForecast>(`/projectmanagement/rolling-forecast/${id}`);
  return response.data;
};

export const createRollingForecast = async (payload: RollingForecastPayload): Promise<RollingForecast> => {
  const response = await axiosInstance.post<RollingForecast>("/projectmanagement/rolling-forecast/", payload);
  return response.data;
};

export const updateRollingForecast = async (
  id: string,
  payload: RollingForecastPayload
): Promise<RollingForecast> => {
  const response = await axiosInstance.put<RollingForecast>(`/projectmanagement/rolling-forecast/${id}`, payload);
  return response.data;
};

export const deleteRollingForecast = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/projectmanagement/rolling-forecast/${id}`);
};

export const getRollingForecastDetails = async (id: string): Promise<RollingForecastDetail[]> => {
  const response = await axiosInstance.get<RollingForecastDetail[]>(`/projectmanagement/rolling-forecast/${id}/details`);
  return response.data;
};

export const createRollingForecastDetail = async (
  id: string,
  payload: RollingForecastDetailPayload
): Promise<RollingForecastDetail> => {
  const response = await axiosInstance.post<RollingForecastDetail>(
    `/projectmanagement/rolling-forecast/${id}/details`,
    payload
  );
  return response.data;
};

export const updateRollingForecastDetail = async (
  id: string,
  detailId: string,
  payload: RollingForecastDetailPayload
): Promise<RollingForecastDetail> => {
  const response = await axiosInstance.put<RollingForecastDetail>(
    `/projectmanagement/rolling-forecast/${id}/details/${detailId}`,
    payload
  );
  return response.data;
};

export const deleteRollingForecastDetail = async (id: string, detailId: string): Promise<void> => {
  await axiosInstance.delete(`/projectmanagement/rolling-forecast/${id}/details/${detailId}`);
};
